interface ErrorPayload {
  message?: unknown
  error?: unknown
}

function initData(): string {
  return window.Telegram?.WebApp?.initData ?? ''
}

export async function apiRequest<Response>(
  url: string,
  options: { method?: 'GET' | 'POST' | 'PUT'; body?: unknown } = {},
): Promise<Response> {
  const telegramInitData = initData()
  if (!telegramInitData) throw new Error('Открой игру из Telegram-бота.')
  const response = await fetch(url, {
    method: options.method ?? 'GET',
    credentials: 'same-origin',
    headers: {
      accept: 'application/json',
      // Заголовок ставится только когда тело действительно есть: с ним, но без
      // тела Fastify пытается разобрать пустой JSON и отвечает 400. Из-за этого
      // кнопка боя на «Прорыве» не работала вообще.
      ...(options.body === undefined ? {} : { 'content-type': 'application/json' }),
      'x-telegram-init-data': telegramInitData,
    },
    ...(options.body === undefined ? {} : { body: JSON.stringify(options.body) }),
  })
  const payload: unknown = await response.json().catch(() => null)
  if (!response.ok) {
    const error = payload as ErrorPayload | null
    throw new Error(
      typeof error?.message === 'string'
        ? error.message
        : `Ошибка запроса (${response.status}). Попробуй ещё раз.`,
    )
  }
  return payload as Response
}

export function prepareTelegram(): void {
  const webApp = window.Telegram?.WebApp
  webApp?.ready()
  webApp?.expand()
}

export function notifyTelegram(type: 'success' | 'warning' | 'error'): void {
  try {
    window.Telegram?.WebApp?.HapticFeedback?.notificationOccurred(type)
  } catch {
    // Старые клиенты Telegram могут не поддерживать тактильный отклик.
  }
}

export function openSiblingGame(url: string): void {
  if (!url) return
  const webApp = window.Telegram?.WebApp
  if (/^https:\/\/t\.me\//.test(url) && webApp?.openTelegramLink) {
    webApp.openTelegramLink(url)
    return
  }
  // Соседняя игра открывается прямо внутри мини-приложения, на том же адресе.
  // Данные входа Telegram кладёт во фрагмент адреса, и при переходе его нужно
  // перенести — иначе вторая игра не увидит подпись и скажет «Открой игру из
  // Telegram-бота». Открывать через openLink нельзя по той же причине: внешний
  // браузер про Telegram ничего не знает.
  const hash = window.location.hash
  window.location.assign(hash && !url.includes('#') ? `${url}${hash}` : url)
}
